import { render, staticRenderFns } from "./TmPart.vue?vue&type=template&id=7b024ef4&"
import script from "./TmPart.vue?vue&type=script&lang=js&"
export * from "./TmPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports